import keyBy from 'lodash/keyBy';
import identity from 'lodash/identity';
import mapValues from 'lodash/mapValues';

function enumFromList(list) {
  return Object.freeze(keyBy([...list], identity));
}

function enumFromObject(obj) {
  const enumerable = mapValues({ ...obj }, (v, k) => k);
  return Object.freeze(enumerable);
}

export {
  enumFromList,
  enumFromObject,
};
